import React from 'react';

export default function ClientCircle() {
  return (
    <svg
      width='24'
      height='24'
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <rect width='24' height='24' rx='12' fill='#18181B' />
      <path
        d='M16.6663 18V16.6667C16.6663 15.9594 16.3854 15.2811 15.8853 14.781C15.3852 14.281 14.7069 14 13.9997 14H9.99967C9.29243 14 8.61415 14.281 8.11406 14.781C7.61396 15.2811 7.33301 15.9594 7.33301 16.6667V18M14.6663 8.66667C14.6663 10.1394 13.4724 11.3333 11.9997 11.3333C10.5269 11.3333 9.33301 10.1394 9.33301 8.66667C9.33301 7.19391 10.5269 6 11.9997 6C13.4724 6 14.6663 7.19391 14.6663 8.66667Z'
        stroke='#A1A1AA'
        stroke-width='1.25'
        stroke-linecap='round'
        stroke-linejoin='round'
      />
    </svg>
  );
}
